export default __webpack_public_path__ + "static/media/back.c1c81252.svg";